<template>
  <div class="image-handle-container">
    <div class="image-box" :class="{'sunny':isSunny,'moon':!isSunny}">
      <div class="background-change-box">
        <i @click.stop="handleBackgroundColor(true)" class="el-icon-sunny change-box-icon" :class="{'active':isSunny}" title="白天模式"></i>
        <i @click.stop="handleBackgroundColor(false)" class="el-icon-moon change-box-icon" :class="{'active':!isSunny}" title="夜间模式"></i>
      </div>
      <img class="image" :src="reviewImagePath||row.path" alt="" object-fit="contain">
    </div>
    <div class="form-box">
      <div class="image-handle-tips">
        <el-tooltip class="item" effect="dark" placement="left-start">
          <div slot="content">
            <p>图片处理需知：</p>
            <p><span class="color-red">*</span>1. 收费&原理：图片处理是一项<a style="text-decoration: underline; color: #409eff;" href="https://cloud.tencent.com/document/product/460/58117" target="__blank">收费</a>内容，是经过拼接参数到腾讯云COS进行处理的。</p>
            <p><span class="color-red">*</span>2. 打开&保存：处理好的图片为了避免CDN回溯收费，尽量把处理后的图片进行保存~
              <br />&nbsp; &nbsp; &nbsp;操作：打开按钮->右键保存图片
            </p>
            <p><span class="color-red">*</span>3. 相信&帮助：为了公司降本增效，作为程序员能用CSS解决图片样式的就用CSS进行处理。</p>
          </div>
          <el-button type="text">
            <i class="el-icon-question tips-icon"></i>
          </el-button>
        </el-tooltip>
      </div>
      <div class="form-tools">
        <el-popover :append-to-body="true" placement="left-start" title="自定义表单" width="252" trigger="hover">
          <div class="diy-my-form">
            <el-checkbox-group v-model="checkForm">
              <el-checkbox v-for="item in allForm" :label="item.value" :key="item.value" :disabled="item.disabled">{{item.label}}</el-checkbox>
            </el-checkbox-group>
            <div class="button-box">
              <el-button type="primary" @click="saveTools" size="mini">保存</el-button>
              <el-button @click="resetTools" size="mini">重置</el-button>
            </div>
          </div>
          <el-button slot="reference" icon="el-icon-suitcase" circle size="mini"></el-button>
        </el-popover>
      </div>
      <el-form ref="form" :model="form" label-width="90px">
        <el-form-item label="webp压缩" v-if="!form.format&&showForms.includes('webp')" :title="webpTitle">
          <el-switch class="switch" v-model="form.webp" @change="webpChangeHandle"></el-switch>
        </el-form-item>
        <el-form-item label="转灰度图" v-if="showForms.includes('grayscale')" :title="supportImageTitle">
          <el-switch class="switch" v-model="form.grayscale" @change="concatParam"></el-switch>
        </el-form-item>
        <el-form-item label="图片缩放" v-if="showForms.includes('thumbnail')" :title="supportImageTitle">
          <el-switch @change="concatParam" class="switch" v-model="form.thumbnail"></el-switch>
          <label class="label">缩放比例</label>
          <el-input-number @change="concatParam" :disabled="!form.thumbnail" v-model="form.thumbnailNum" :step="5" size="mini" :min="1" :max="100" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="图片裁剪" v-if="showForms.includes('cut')" :title="defaultSupportTitle">
          <el-switch @change="concatParam" class="switch" v-model="form.cut" :disabled="!canDefaultHandle"></el-switch>
          <label class="label">裁剪方式</label>
          <el-select @change="cutTypeChange" :disabled="!form.cut" v-model="form.cutType" placeholder="请选择" style="width:130px;">
            <el-option :disabled="row.ext===item.disabledType" v-for="item in cutTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <div v-if="form.cutType==='cut'" class="cut-box">
            <label class="label">宽</label>
            <el-input-number @change="concatParam" :disabled="!form.cut" v-model="form.width" :step="5" size="mini" :min="1" :max="imageInfo.width" controls-position="right"></el-input-number>
            <label class="label">高</label>
            <el-input-number @change="concatParam" :disabled="!form.cut" v-model="form.height" :step="5" size="mini" :min="1" :max="imageInfo.height" controls-position="right"></el-input-number>
            <label class="label">右偏移</label>
            <el-input-number @change="concatParam" :disabled="!form.cut" v-model="form.dx" :step="5" size="mini" :min="0" :max="imageInfo.width" controls-position="right"></el-input-number>
            <label class="label">下偏移</label>
            <el-input-number @change="concatParam" :disabled="!form.cut" v-model="form.dy" :step="5" size="mini" :min="0" :max="imageInfo.height" controls-position="right"></el-input-number>
          </div>
          <div v-else-if="form.cutType==='crop'" class="cut-box crop-box">
            <label class="label">宽</label>
            <el-input-number @change="concatParam" :disabled="!form.cut" v-model="form.width" :step="5" size="mini" :min="0" :max="imageInfo.width" controls-position="right"></el-input-number>
            <label class="label">高</label>
            <el-input-number @change="concatParam" :disabled="!form.cut" v-model="form.height" :step="5" size="mini" :min="0" :max="imageInfo.height" controls-position="right"></el-input-number>
            <label class="label">参考点</label>
            <el-select @change="concatParam" :disabled="!form.cut" v-model="form.gravity" placeholder="请选择" style="width:130px;">
              <el-option v-for="item in gravityList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
          <div v-else-if="form.cutType==='scrop'" class="cut-box crop-box">
            <label class="label">宽</label>
            <el-input-number @change="concatParam" :disabled="!form.cut" v-model="form.width" :step="5" size="mini" :min="1" :max="imageInfo.width" controls-position="right"></el-input-number>
            <label class="label">高</label>
            <el-input-number @change="concatParam" :disabled="!form.cut" v-model="form.height" :step="5" size="mini" :min="1" :max="imageInfo.height" controls-position="right"></el-input-number>
          </div>
          <div v-else class="cut-box other-box">
            <label class="label">{{this.form.cutType==='iradius'?'内切圆半径':'圆角边缘半径'}}</label>
            <el-input-number @change="concatParam" :disabled="!form.cut" v-model="form.radius1" size="mini" :min="1" :max="maxRadius" controls-position="right"></el-input-number>
          </div>
        </el-form-item>
        <el-form-item label="图片亮度" v-if="showForms.includes('bright')" :title="defaultSupportTitle">
          <el-switch @change="concatParam" class="switch" v-model="form.bright" :disabled="!canDefaultHandle"></el-switch>
          <label class="label">亮度调节</label>
          <el-input-number @change="concatParam" :disabled="!form.bright" v-model="form.brightNum" :step="5" size="mini" :min="-100" :max="100" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="图对比度" v-if="showForms.includes('contrast')" :title="defaultSupportTitle">
          <el-switch @change="concatParam" class="switch" v-model="form.contrast" :disabled="!canDefaultHandle"></el-switch>
          <label class="label">对比度数</label>
          <el-input-number @change="concatParam" :disabled="!form.contrast" v-model="form.contrastNum" :step="5" size="mini" :min="-100" :max="100" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="图片锐化" v-if="showForms.includes('sharpen')" :title="defaultSupportTitle">
          <el-switch @change="concatParam" class="switch" v-model="form.sharpen" :disabled="!canDefaultHandle"></el-switch>
          <label class="label">锐化数值</label>
          <el-input-number @change="concatParam" :disabled="!form.sharpen" v-model="form.sharpenNum" :step="10" size="mini" :min="10" :max="300" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="图片旋转" v-if="showForms.includes('rotate')" :title="defaultSupportTitle">
          <el-switch @change="concatParam" class="switch" v-model="form.rotate" :disabled="!canDefaultHandle"></el-switch>
          <label class="label">旋转度数</label>
          <el-input-number @change="concatParam" :disabled="!form.rotate" v-model="form.rotateNum" :step="15" size="mini" :min="1" :max="360" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="质量变换" v-if="showForms.includes('quality')" :title="qualityTitle">
          <el-switch @change="concatParam" class="switch" v-model="form.quality" :disabled="!(qualityImages.includes(row.ext)||form.webp)"></el-switch>
          <el-radio-group @change="concatParam" :disabled="!form.quality" v-model="form.qualityType" size="mini" style="margin:0 15px;">
            <el-radio-button label="quality">绝对质量</el-radio-button>
            <el-radio-button label="rquality">相对质量</el-radio-button>
            <el-radio-button label="lquality">最低质量</el-radio-button>
          </el-radio-group>
          <el-input-number @change="concatParam" :disabled="!form.quality" v-model="form.qualityNum" :step="5" size="mini" :min="1" :max="100" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="格式转换" v-if="!form.webp&&showForms.includes('format')" :title="imageFormatTitle">
          <el-switch class="switch" v-model="form.format" @change="formatChangeHandle"></el-switch>
          <label class="label">可转格式</label>
          <el-radio-group v-model="form.formatType" @change="concatParam">
            <el-radio :disabled="!form.format" v-for="item in formatImages" :key="item" :label="item"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="高斯模糊" v-if="showForms.includes('blur')" :title="defaultSupportTitle">
          <el-switch @change="concatParam" class="switch" v-model="form.blur" :disabled="!canDefaultHandle">
          </el-switch>
          <div class="blur-config-box">
            <label class="label">模糊半径</label>
            <el-input-number @change="concatParam" :disabled="!form.blur" v-model="form.radius" size="mini" :min="1" :max="50" controls-position="right"></el-input-number>
            <label class="label">正态分布的标准差</label>
            <el-input-number @change="concatParam" :disabled="!form.blur" v-model="form.sigma" size="mini" :min="1" controls-position="right"></el-input-number>
          </div>
        </el-form-item>
        <el-form-item label="错误处理" v-if="showForms.includes('error')" :title="supportImageTitle">
          <el-switch @change="concatParam" class="switch" v-model="form.error"></el-switch>
          <label class="label">图片处理失败</label>
          <el-radio-group v-model="form.errHandle" @change="concatParam">
            <el-radio :disabled="!form.error" :label="true">返回原图</el-radio>
            <el-radio :disabled="!form.error" :label="false">返回错误</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div class="button-box">
      <el-button type="info" @click="reviewImage">预览</el-button>
      <el-button type="primary" v-clipboard:copy="handleImagePath||row.path" v-clipboard:success="onCopy">复制</el-button>
      <el-button type="success" @click="downloadImage">打开</el-button>
      <el-button type="danger" @click="resetFormData">重置</el-button>
    </div>
  </div>
</template>

<script>
const defaultHandleForm = {
  format: false,
  cut: false,
  quality: false,
  blur: false,
  webp: false,
  thumbnail: false,
  rotate: false,
  bright: false,
  error: false,
  contrast: false,
  sharpen: false,
  grayscale: false,
  radius: 8,
  sigma: 5,
  thumbnailNum: 50,
  qualityNum: 60,
  rotateNum: 90,
  contrastNum: -50,
  sharpenNum: 70,
  formatType: '',
  cutType: 'cut',
  qualityType: 'quality',
  gravity: '',
  brightNum: 70,
  width: 100,
  height: 100,
  dx: 0,
  dy: 0,
  radius1: 0,
  errHandle: false
}
const defaultCheckForm = ['webp', 'thumbnail', 'rotate', 'format', 'blur', 'error']
export default {
  props: {
    row: {
      type: Object,
      default: () => { }
    },
    imageInfo: {
      type: Object,
    }
  },
  data () {
    return {
      isSunny: true,
      form: JSON.parse(JSON.stringify(defaultHandleForm)),
      dynamicImages: ['gif', 'webp', 'tpg'],
      staticImages: ['jpg', 'png', 'bmp', 'tpg', 'heif'],
      imageFormatTitle: 'gif、webp、tpg 等动图，支持互相转换；jpg、png、bmp、tpg、heif 等静态图片，支持互相转换。',
      qualityImages: ['jpg', 'webp', 'tpg', 'heif', 'avif'],
      qualityTitle: '支持 jpg、webp、tpg、heif、avif 格式图片',
      defaultSupportImages: ['jpg', 'bmp', 'gif', 'png', 'webp'],
      defaultSupportTitle: '支持处理 JPG、BMP、GIF、PNG、WEBP 格式',
      supportImageTitle: '支持所有格式图片',
      webpTitle: '支持将 jpg、png、bmp、gif、tpg、heif、avif 等格式图片转换为 webp 格式',
      handleImagePath: '',
      reviewImagePath: '',
      cutTypeList: [{
        label: '普通裁剪',
        value: 'cut'
      }, {
        label: '缩放裁剪',
        value: 'crop'
      }, {
        label: '内切圆裁剪',
        value: 'iradius',
        disabledType: 'gif'
      },
      {
        label: '圆角裁剪',
        value: 'rradius',
        disabledType: 'gif'
      },
      {
        label: '人脸智能裁剪',
        value: 'scrop'
      }],
      gravityList: ['north', 'south', 'west', 'east', 'center'],
      maxRadius: 100,
      checkForm: JSON.parse(JSON.stringify(defaultCheckForm)),
      showForms: [],
      allForm: [{
        label: 'webp压缩',
        value: 'webp',
        disabled: true
      }, {
        label: '转灰度图',
        value: 'grayscale'
      }, {
        label: '图片缩放',
        value: 'thumbnail'
      }, {
        label: '图片裁剪',
        value: 'cut'
      }, {
        label: '图片亮度',
        value: 'bright'
      }, {
        label: '图对比度',
        value: 'contrast'
      }, {
        label: '图片锐化',
        value: 'sharpen'
      }, {
        label: '图片旋转',
        value: 'rotate'
      }, {
        label: '质量变换',
        value: 'quality'
      }, {
        label: '格式转换',
        value: 'format'
      }, {
        label: '高斯模糊',
        value: 'blur'
      }, {
        label: '错误处理',
        value: 'error'
      }]
    }
  },
  watch: {
    imageInfo: {
      deep: true,
      handler (data) {
        this.initCutWHR(data);
      }
    },
  },
  computed: {
    isDynamic () {
      return this.dynamicImages.includes(this.row.ext);
    },
    formatImages () {
      if (this.isDynamic) {
        let index = this.dynamicImages.indexOf(this.row.ext);
        let data = this.dynamicImages;
        data.splice(index, 1);
        return data;
      } else {
        let index = this.staticImages.indexOf(this.row.ext);
        if (index !== -1) {
          let data = this.staticImages;
          data.splice(index, 1);
          return data;
        } else {
          return this.staticImages;
        }
      }
    },
    canDefaultHandle () {
      return this.defaultSupportImages.includes(this.row.ext) || this.form.webp;
    }
  },
  mounted () {
    const isSunny = localStorage.getItem('IS_SUNNY');
    const myDiyForm = localStorage.getItem('MY_DIY_FORM');
    if (isSunny) this.isSunny = isSunny === 'true' ? true : false;
    if (this.imageInfo) {
      this.initCutWHR(this.imageInfo);
    }
    this.checkForm = (myDiyForm ? JSON.parse(myDiyForm) : '') || this.checkForm;
    this.showForms = this.checkForm;
  },
  methods: {
    // 当裁剪类型发送变化 触发函数
    cutTypeChange () {
      this.concatParam();
      // 初始化剪裁宽、高、半径
      this.initCutWHR(this.imageInfo);
    },
    // 初始化剪裁宽、高、半径
    initCutWHR (data) {
      const defaultRadius = data.width > data.height ? Math.floor(data.height / 2) : Math.floor(data.width / 2);
      this.form.width = data.width;
      this.form.height = data.height;
      this.form.radius1 = defaultRadius;
      this.maxRadius = defaultRadius;
    },
    // 下载
    downloadImage () {
      window.open(this.handleImagePath || this.row.path);
    },
    // 复制
    onCopy () {
      this.$message.success('文件地址复制成功', 2);
    },
    webpChangeHandle (data) {
      if (data) {
        this.form.format = false;
        this.form.formatType = '';
        if (!this.qualityImages.includes(this.row.ext)) {
          this.form.quality = false;
        }
      }
      this.concatParam();
    },
    formatChangeHandle (data) {
      if (data) {
        this.form.webp = false;
      }
      this.concatParam();
    },
    // 拼接参数
    concatParam () {
      let { webp, grayscale, cut, contrast, format, quality, blur, thumbnail, error, bright, rotate, formatType, qualityType, thumbnailNum, rotateNum, qualityNum, contrastNum, brightNum, errHandle, radius, sigma, sharpen, sharpenNum } = this.form;
      let imagePath = this.row.path;
      let hasParam = webp || grayscale || cut || (bright && brightNum) || (format && formatType) || rotate || quality || blur || thumbnail || (contrast && contrastNum) || (sharpen && sharpenNum);
      // 图片处理 参数拼接
      if (hasParam) {
        imagePath = `${imagePath}?imageMogr2`;
      }
      // 图片压缩
      if (webp) {
        imagePath = `${imagePath}/format/webp`;
      }
      // 转灰度图
      if (grayscale) {
        imagePath = `${imagePath}/grayscale/1`;
      }
      // 图片缩放
      if (thumbnail) {
        imagePath = `${imagePath}/thumbnail/!${thumbnailNum}p`;
      }
      // 图片锐化
      if (sharpen) {
        imagePath = `${imagePath}/sharpen/${sharpenNum}`;
      }
      // 图片裁剪
      if (cut) {
        imagePath = this.cutParamConcat(imagePath);
      }
      // 亮度调节
      if (bright && brightNum) {
        imagePath = `${imagePath}/bright/${brightNum}`;
      }
      // 对比度调节
      if (contrast && contrastNum) {
        imagePath = `${imagePath}/contrast/${contrastNum}`;
      }
      // 图片旋转
      if (rotate) {
        imagePath = `${imagePath}/rotate/${rotateNum}`;
      }
      // 图片质量
      if (quality) {
        imagePath = this.qualityParamConcat(imagePath, qualityType, qualityNum)
      }
      // 格式转换
      if (format && formatType) {
        imagePath = `${imagePath}/format/${formatType}`;
      }
      // 模糊处理
      if (blur) {
        imagePath = `${imagePath}/blur/${radius}x${sigma}`;
      }
      // 错误处理
      if (error && errHandle && hasParam) {
        imagePath = `${imagePath}/ignore-error/1`;
      }
      this.handleImagePath = imagePath;
    },
    // 质量参数拼接
    qualityParamConcat (imagePath, qualityType, qualityNum) {
      switch (qualityType) {
        case 'quality':
          imagePath = `${imagePath}/quality/${qualityNum}`;
          break;
        case 'rquality':
          imagePath = `${imagePath}/rquality/${qualityNum}`;
          break;
        case 'lquality':
          imagePath = `${imagePath}/lquality/${qualityNum}`;
          break;
      }
      return imagePath;
    },
    // 裁剪参数拼接
    cutParamConcat (imagePath) {
      switch (this.form.cutType) {
        case 'cut':
          imagePath = `${imagePath}/cut/${this.form.width}x${this.form.height}${this.form.dx ? ('x' + this.form.dx) : ''}${this.form.dy ? ('x' + this.form.dy) : ''}`;
          break;
        case 'crop':
          imagePath = `${imagePath}/crop/${this.form.width || ''}x${this.form.height || ''}${this.form.gravity ? '/gravity/' + this.form.gravity : ''}`;
          break;
        case 'iradius':
          imagePath = `${imagePath}/iradius/${this.form.radius1}`;
          break;
        case 'rradius':
          imagePath = `${imagePath}/rradius/${this.form.radius1}`;
          break;
        default:
          imagePath = `${imagePath}/scrop/${this.form.width}x${this.form.height}`;
          break;
      }
      return imagePath;
    },
    // 预览图片
    reviewImage () {
      this.reviewImagePath = this.handleImagePath;
    },
    // 背景颜色处理
    handleBackgroundColor (isSunny) {
      this.isSunny = isSunny;
      localStorage.setItem('IS_SUNNY', isSunny);
    },
    // 重置表单
    resetFormData () {
      this.reviewImagePath = '';
      this.handleImagePath = '';
      this.form = JSON.parse(JSON.stringify(defaultHandleForm));
      this.concatParam();
      this.$refs['form'].resetFields();
    },
    // 保存自定义表单
    saveTools () {
      this.showForms = this.checkForm;
      localStorage.setItem('MY_DIY_FORM', JSON.stringify(this.showForms));
    },
    // 重置自定义表单
    resetTools () {
      this.checkForm = JSON.parse(JSON.stringify(defaultCheckForm));
      this.showForms = this.checkForm;
      localStorage.removeItem('MY_DIY_FORM');
      this.resetFormData();
    }
  }
}
</script>

<style lang="scss" scoped>
.image-handle-container {
  .image-box {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    // width: 100%;
    min-height: 340px;
    &.sunny {
      color: #606266;
      background-color: #fbfbfb;
    }
    &.moon {
      color: #fff;
      background-color: #000;
    }
    .image {
      max-width: 70%;
      max-height: 340px;
    }
    .background-change-box {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 16px;
      border: 1px solid #ccc;
      border-radius: 6px;
      .change-box-icon {
        font-weight: 500;
        padding: 5px 8px;
        cursor: pointer;
        &:nth-last-child(1) {
          border-left: 1px solid #ccc;
        }
        &:hover {
          color: #409eff;
        }
        &.active {
          font-weight: 700;
          color: #409eff;
        }
      }
    }
  }
  .form-box {
    position: relative;
    .image-handle-tips {
      position: absolute;
      top: -10px;
      right: 10px;
      z-index: 1;
      .tips-icon {
        padding: 5px;
        font-size: 26px;
        color: #5862ab;
      }
    }
    .form-tools {
      position: absolute;
      top: 5px;
      right: 55px;
      z-index: 1;
    }
    .switch {
      margin-right: 25px;
    }
    .label {
      margin: 0 15px;
    }
    .blur-config-box {
      display: inline-block;
    }
    .cut-box {
      display: inline-block;
      margin: 15px 0 0 65px;
      &.crop-box,
      &.other-box {
        margin: 0;
      }
    }
  }
  .button-box {
    margin-top: 30px;
    width: 100%;
    text-align: center;
  }
}
</style>